import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import { DisApprovedStatusDialogValues } from './DisApprovedStatusDialogWrapper';
import ATMTextArea from 'src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea';

type Props = {
  formikProps: FormikProps<DisApprovedStatusDialogValues>;
  onClose: () => void;
};

const DisApprovedStatusDialog = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>Reject Request</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        <div>
          <ATMTextArea
            name='reason'
            value={values?.reason}
            onChange={(e) => {
              setFieldValue('reason', e);
            }}
            label='Reason'
            placeholder='Enter Reason'
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default DisApprovedStatusDialog;